import { Typography } from '@altify/components';
import { ActiveProductDtoTypeEnum } from 'services/generated';
import { useProductsGraphs } from 'hooks/products/useGraphs';
import GainLoss from 'components/GainLoss/GainLoss';
import { useContent } from '@altify/utils';
import { exploreProductsContent } from '../explore.content';

export function ExploreGainLoss({
  productCode,
  productType,
  productGraph,
  isTracked,
}: {
  productCode: string;
  productType: ActiveProductDtoTypeEnum;
  productGraph: ReturnType<typeof useProductsGraphs>;
  isTracked: boolean;
}) {
  const localizedContent = useContent(exploreProductsContent);

  return productType === ActiveProductDtoTypeEnum.PrivateCredit ? (
    <div className="flex flex-col items-end">
      <GainLoss
        value={11}
        isPercentage
        background={true}
        hidePrefix={true}
      />
      <Typography size="medium" className="text-white">
        {localizedContent.annualYield}
      </Typography>
    </div>
  ) : isTracked ? (
    <GainLoss
      background={true}
      loading={productGraph.isLoading || productGraph.isFetching}
      value={getPercentageChangeForTimeFrameKey(productCode, productGraph)}
      className='-mr-0.5'
    />
  ) : (
    null
  );
}

const getPercentageChangeForTimeFrameKey = (
  productCode: string,
  timeFrameGraphs: ReturnType<typeof useProductsGraphs>,
) => {
  const graph = timeFrameGraphs?.graphs?.find(
    g => g.productCode === productCode.toUpperCase(),
  );
  const assetGainPercentage =
    graph == null
      ? null
      : graph.graph[graph.graph.length - 1].relativeChange * 100;
  return assetGainPercentage;
};
